export const data2 =
{
    scene: 'scene_02_pitosyvyys',
    kysymysteksti: 'Ok, nyt on oikea paikka löytynyt ja seuraavaksi sitten täytyy pistää. Suorita pisto oikeaan syvyyteen ja kun olet siellä, klikkaa injektoi. Lopuksi vedä neula ulos.',

    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'Subcutaanikudokseen osui niinkuin pitääkin',
            valinta: 'SC',
            ohjaajan_palaute: '',
            koontiteksti: '',
            pisteet: 1,
            arviointitiedosto: 'scene_02_pistosyvyys_ok',
            kuva: '',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 1,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }

            ]
        },
        {
            id: 2,
            teksti: 'syvyys ei oikea',
            valinta: 'wrong depth',
            ohjaajan_palaute: '',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_02_pistosyvyys_ei_ok',
            kuva: '',
            harjoiteltava: ["pistämistä"],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 1,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }

            ]
        }

    ]
};



